module.exports = __webpack_public_path__ + "media/images/logo_title-05adde3941152a954cbd6358818ee764.png";